import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideAssignCicToUserModal } from './assignCicToUserModal';
import { getCicAlerts } from './getCicAlerts';

export const ASSIGN_CIC_TO_USER_REQUEST = 'ASSIGN_CIC_TO_USER_REQUEST';
export const ASSIGN_CIC_TO_USER_SUCCESS = 'ASSIGN_CIC_TO_USER_SUCCESS';
export const ASSIGN_CIC_TO_USER_ERROR = 'ASSIGN_CIC_TO_USER_ERROR';

function requestAssignCicToUser() {
  return {
    type: ASSIGN_CIC_TO_USER_REQUEST,
  };
}

function receiveAssignCicToUser() {
  return {
    type: ASSIGN_CIC_TO_USER_SUCCESS
  };
}

function rejectAssignCicToUser() {
  return {
    type: ASSIGN_CIC_TO_USER_ERROR
  };
}

export function assignCicsToUser(cicAlertList, user, currentPageNumber, currentPageSize) {
  return (dispatch) => {
    dispatch(requestAssignCicToUser());

    const promise = () => ApiService
      .assignCicToUser(cicAlertList, user.id)
      .then((response) => {
        dispatch(hideAssignCicToUserModal());
        dispatch(receiveAssignCicToUser(response.data));
        toastr.success('', 'The user has been successfully assigned');
        return dispatch(getCicAlerts(currentPageNumber, currentPageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAssignCicToUser, true));
        }
      });
    return promise();
  };
}

export function assignCicsToUserWithCallback(cicAlertList, user, callback) {
  return (dispatch) => {
    dispatch(requestAssignCicToUser());

    const promise = () => ApiService
      .assignCicToUser(cicAlertList, user.id)
      .then((response) => {
        dispatch(hideAssignCicToUserModal());
        dispatch(receiveAssignCicToUser(response.data));
        toastr.success('', 'The user has been successfully assigned');
        callback();
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAssignCicToUser, true));
        }
      });
    return promise();
  };
}
